import * as SeparatorRadix from '@radix-ui/react-separator';
import './separator.scss';
import classNames from 'classnames';

interface Props {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
}

export const Separator = ({ className, orientation = 'horizontal' }: Props) => (
  <SeparatorRadix.Root
    className={classNames('payflow-ui payflow-separator', className)}
    decorative
    orientation={orientation}
  />
);
